
import React from 'react';

const googleReviews = [
  {
    id: 1,
    name: "Michael Rodriguez",
    date: "2 weeks ago",
    rating: 5,
    text: "Desert Edge Outdoors did an amazing job on our pool deck. The team was professional, on time, and the quality exceeded our expectations. Highly recommend!",
    avatar: "M"
  },
  {
    id: 2,
    name: "Jennifer Thompson",
    date: "1 month ago",
    rating: 5,
    text: "We had synthetic grass installed in our backyard and couldn't be happier. The crew was efficient and cleaned up everything. Our yard looks incredible now!",
    avatar: "J"
  },
  {
    id: 3,
    name: "David Chen",
    date: "1 month ago",
    rating: 5,
    text: "Best landscaping company in Las Vegas! They transformed our entire outdoor space with beautiful pavers and a new pool deck. Worth every penny.",
    avatar: "D"
  },
  {
    id: 4,
    name: "Amanda Garcia",
    date: "2 months ago",
    rating: 5,
    text: "Excelente servicio! They speak Spanish which made communication so easy. Our patio looks stunning. Very professional team.",
    avatar: "A"
  },
  {
    id: 5,
    name: "Robert Williams",
    date: "2 months ago",
    rating: 5,
    text: "Had our pool replastered and it looks brand new. The team was knowledgeable and completed the job ahead of schedule. Will definitely use again!",
    avatar: "R"
  },
  {
    id: 6,
    name: "Sarah Martinez",
    date: "3 months ago",
    rating: 5,
    text: "From start to finish, Desert Edge Outdoors was fantastic. They helped us design the perfect outdoor kitchen and executed it flawlessly.",
    avatar: "S"
  }
];

export function GoogleReviews() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header with Google Rating */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <svg className="w-10 h-10" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-2xl font-bold text-gray-800">Google Reviews</span>
          </div>
          
          {/* Rating Summary */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="text-5xl font-bold text-gray-900">4.9</div>
            <div className="text-left">
              <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-[#FBBC05] text-xl"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm">Based on 127 reviews</p>
            </div>
          </div>
          
          {/* Review on Google Button */}
          <a 
            href="https://www.google.com/search?q=Desert+Edge+Outdoors+Las+Vegas+reviews" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-gray-300 rounded-full text-gray-700 font-medium hover:bg-gray-50 hover:shadow-md transition-all cursor-pointer whitespace-nowrap"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Review us on Google
          </a>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {googleReviews.map((review) => (
            <div 
              key={review.id}
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Review Header */}
              <div className="flex items-start gap-4 mb-4">
                <div className="w-10 h-10 rounded-full bg-[#FF6B35] flex items-center justify-center text-white font-semibold">
                  {review.avatar}
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-900">{review.name}</h4>
                  <p className="text-gray-500 text-sm">{review.date}</p>
                </div>
                <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
              </div>
              
              {/* Stars */}
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i 
                    key={star} 
                    className={`ri-star-fill text-lg ${star <= review.rating ? 'text-[#FBBC05]' : 'text-gray-300'}`}
                  ></i>
                ))}
              </div>
              
              {/* Review Text */}
              <p className="text-gray-700 text-sm leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>

        {/* See All Reviews Link */}
        <div className="text-center mt-10">
          <a 
            href="https://www.google.com/search?q=Desert+Edge+Outdoors+Las+Vegas+reviews" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#FF6B35] font-semibold hover:underline cursor-pointer"
          >
            See all reviews on Google
            <i className="ri-external-link-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
